import { useState } from "react";
import { api, formatError } from "@/lib/api";
import { Honeypot } from "@/components/forms/FormParts";

const RATINGS = [["yes", "Yes"], ["partly", "Partly"], ["not_yet", "Not yet"]];

export const JourneyFeedback = ({ slug }) => {
  const [rating, setRating] = useState(null);
  const [comment, setComment] = useState("");
  const [hp, setHp] = useState("");
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");
  const send = async () => {
    setStatus("sending");
    setError("");
    try {
      await api.post("/feedback", { journey: slug, rating, comment, company_website: hp });
      setStatus("sent");
    } catch (e) {
      setError(formatError(e));
      setStatus("idle");
    }
  };
  if (status === "sent") return <p className="card-soft p-6 font-semibold" role="status" data-testid="journey-feedback-thanks">Thank you. Your feedback helps us improve Addiction &amp; Us.</p>;
  return (
    <section className="relative card-soft !bg-white p-6 sm:p-8" aria-labelledby="feedback-heading" data-testid="journey-feedback">
      <h2 id="feedback-heading" className="text-2xl">Did this help you find a way forward?</h2>
      <div className="mt-4 flex flex-wrap gap-2" role="radiogroup" aria-label="Did this help?">
        {RATINGS.map(([v, l]) => (
          <button key={v} type="button" role="radio" aria-checked={rating === v} onClick={() => setRating(v)}
            className={`rounded-full border-2 px-5 py-2.5 min-h-[44px] font-semibold transition-colors ${rating === v ? "border-teal bg-teal text-cream" : "border-ink/15 hover:border-ink/40"}`}
            data-testid={`journey-feedback-${v}`}>{l}</button>
        ))}
      </div>
      {rating && (
        <div className="mt-5">
          <label htmlFor="feedback-comment" className="field-label">What could we improve? (optional)</label>
          <textarea id="feedback-comment" className="field min-h-[100px]" maxLength={500} value={comment} onChange={(e) => setComment(e.target.value)} data-testid="journey-feedback-comment" />
          <Honeypot value={hp} onChange={setHp} />
          {error && <p role="alert" className="mt-2 text-clay-dark font-semibold">{error}</p>}
          <button type="button" onClick={send} disabled={status === "sending"} className="btn-primary mt-4" data-testid="journey-feedback-submit">{status === "sending" ? "Sending…" : "Send feedback"}</button>
        </div>
      )}
      <p className="mt-4 text-sm text-ink-muted">Anonymous. Please don't include names or personal details. We only use feedback to improve this website. It is seen by our administrators only and deleted automatically after 12 months. Your journey answers are never sent.</p>
    </section>
  );
};
